import React from "react";

const DIGITS_TOP = [7, 8, 9, 4, 5, 6, 1, 2, 3];

// Contextual control bar for the running game; the active UI is driven by
// the IO bridge's current input mode (controls.mode).
export const GameControls = ({ io, controls, nameVal, setNameVal, onProfit }) => (
  <div className="controls" data-testid="controls-area">
    {controls.mode === "key" && (
      <button className="rbtn wide primary" data-testid="key-continue-btn" onClick={() => io.handleCanvasTap(0, 0)}>
        {controls.label || "המשך"} ◄
      </button>
    )}

    {controls.mode === "help" && (
      <button className="rbtn wide" data-testid="help-close-btn" onClick={() => io.toggleHelp()}>
        חזרה למשחק
      </button>
    )}

    {controls.mode === "options" && (
      <div className="options-bar">
        {(controls.optionButtons || []).length > 0 ? (
          <div className="option-btns" data-testid="option-btns">
            {controls.optionButtons.map((b) => (
              <button
                key={b.idx}
                className="rbtn option"
                data-testid={`option-btn-${b.idx}`}
                onClick={() => io.pressOptionButton(b.idx)}
              >
                <span className="option-idx">{b.idx}</span>
                <span className="option-label">{b.label}</span>
              </button>
            ))}
          </div>
        ) : (
          <div className="hint" data-testid="options-hint">
            בחר אפשרות על המסך
          </div>
        )}
        {(controls.actions || []).map((a) => (
          <button
            key={a.value}
            className="rbtn small action"
            data-testid={`option-action-${a.value}`}
            onClick={() => io.pressAction(a.value)}
          >
            {a.label}
          </button>
        ))}
        {onProfit && (
          <button className="rbtn small info" data-testid="profit-helper-btn" onClick={onProfit}>
            טבלת עזר
          </button>
        )}
        {controls.escapable && (
          <button className="rbtn small" data-testid="esc-btn" onClick={() => io.pressEscape()}>
            {controls.escLabel || "חזרה"}
          </button>
        )}
      </div>
    )}

    {controls.mode === "choice" && (
      <div className="choice-bar">
        {(controls.keys || []).map((k) => (
          <button
            key={k.key}
            className={`rbtn ${k.key === "enter" ? "primary" : ""}`}
            data-testid={`choice-btn-${k.key}`}
            onClick={() => io.pressChoice(k.key)}
          >
            {k.label}
          </button>
        ))}
      </div>
    )}

    {controls.mode === "yesno" && (
      <div className="choice-bar">
        <button className="rbtn primary" data-testid="yes-btn" onClick={() => io.pressYes()}>
          כן
        </button>
        <button className="rbtn" data-testid="no-btn" onClick={() => io.pressNo()}>
          לא
        </button>
      </div>
    )}

    {controls.mode === "number" && (
      <div className="keypad-wrap">
        {controls.quick && controls.quick.length > 0 && (
          <div className="quick-row">
            {controls.quick.map((q, i) => (
              <button
                key={`${q.label}-${q.value}`}
                className="rbtn tiny quick"
                data-testid={`quick-btn-${i}`}
                onClick={() => io.pressQuick(q.value)}
              >
                {q.label} ({Math.floor(q.value)})
              </button>
            ))}
          </div>
        )}
        <div className="keypad">
          {DIGITS_TOP.map((d) => (
            <button key={d} className="kbtn" data-testid={`keypad-digit-${d}`} onClick={() => io.pressDigit(d)}>
              {d}
            </button>
          ))}
          <button className="kbtn alt" data-testid="keypad-backspace" onClick={() => io.pressBackspace()}>
            ⌫
          </button>
          <button className="kbtn" data-testid="keypad-digit-0" onClick={() => io.pressDigit(0)}>
            0
          </button>
          <button className="kbtn ok" data-testid="keypad-confirm" onClick={() => io.pressNumberConfirm()}>
            אישור
          </button>
        </div>
        {controls.escapable !== false && (
          <button className="rbtn small cancel" data-testid="keypad-cancel" onClick={() => io.pressEscape()}>
            ביטול
          </button>
        )}
      </div>
    )}

    {controls.mode === "name" && (
      <div className="name-wrap">
        <div className="hint">כל הכבוד! נכנסת לטבלת השיאים - הכנס את שמך:</div>
        <div className="name-row">
          <input
            className="name-input"
            data-testid="name-input"
            type="text"
            maxLength={16}
            value={nameVal}
            autoFocus
            onChange={(e) => {
              setNameVal(e.target.value);
              io.nameChanged(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                io.submitName(nameVal);
                setNameVal("");
              }
            }}
            placeholder="השם שלך"
          />
          <button
            className="rbtn primary"
            data-testid="name-submit-btn"
            onClick={() => {
              io.submitName(nameVal);
              setNameVal("");
            }}
          >
            אישור
          </button>
        </div>
      </div>
    )}

    {!controls.mode && <div className="hint dim">...</div>}
  </div>
);
